import { DEFAULT_COLORS } from 'constants/colors';

/**
 * Build the default branding for the app.
 *
 * @type {Object}
 */
export const DEFAULT_BRANDING = {
    activeTabColor: DEFAULT_COLORS.BRAND_PEACH_2,
    avatarBackgroundColor: DEFAULT_COLORS.TAN,
    companyName: 'Mineral Corporation',
    linkTextColor: DEFAULT_COLORS.LINK,
    loginLogoUrl: "https://s3-us-west-2.amazonaws.com/cdn.trustmineral-staging.com/assets/Mineral-Logo-Citrine.svg",
    logoUrl: "https://s3-us-west-2.amazonaws.com/cdn.trustmineral-staging.com/assets/Mineral-Logo-Graphite.svg",
    topNavColor: DEFAULT_COLORS.TAN,
    navigationHighlightColor: DEFAULT_COLORS.TAN,
    topNavTextColor: DEFAULT_COLORS.BLACK,
    topNavAccentColor: DEFAULT_COLORS.BRAND_PEACH_2,
    primaryColor: DEFAULT_COLORS.BLUE,
    primaryTextColor: DEFAULT_COLORS.BLACK,
    secondaryColor: DEFAULT_COLORS.LIGHTBLUE,
    secondaryTextColor: DEFAULT_COLORS.BLACK,
    partnerName: '',
    platformName: '',
    platformDomain: '',

    complianceIcon1BgColor         : '#1488E6',
    complianceIcon2BgColor         : '#106DB8',
    complianceIcon3BgColor         : '#1488E6',
    complianceIcon4BgColor         : '#106DB8',
    complianceIcon5BgColor         : '#1488E6',
    complianceIcon6BgColor         : '#106DB8',
    complianceIcon7BgColor         : '#1488E6',
    complianceNavBgColor           : '#1787e8',
    complianceNavTextColor         : '#FFFFFF',
    compliancePopularTopicBgColor  : '#1686E8',
    compliancePopularTopicTextColor: '#6DB5F3',
    dashboardAdvisorBg             : '#212c3b',
    dashboardAdvisorSubmit         : '#f66b1c',
    dashboardAdvisorSubmitText     : '#FFFFFF',
    dashboardBenifitsHighlight     : '#ff7800',
    dashboardComplianceHighlight   : '#1adf0b',
    dashboardHandbookHighlight     : '#1e95ee',
    dashboardTrainingHighlight     : '#b86dc9',
    dashboardSupportHighlight      : '#1e95ee',
};
